import contentControls from "./contentControlsService";
import { CONTENT_BLOCK } from "@/constants/contentControlTypes";
import { CONTENT_BLOCK as CONTENT_BLOCK_COLOR } from "@/constants/contentControlColors";
import { tryLoadProperties } from "@/util/wordUtil";

const add = (systemName, displayName = "", hideBoundingBox = false) => new Promise(resolve => {
    if (!displayName) {
        displayName = systemName
    }

    const title = `Sharedo ${CONTENT_BLOCK}: ${displayName}`;
    const options = {
        placeholderText: title,
        color: CONTENT_BLOCK_COLOR,
        tag: systemName,
        hideBoundingBox
    };

    contentControls.insert(title, options, async ({ contentControl, parentContentControl, context }) => {
        tryLoadProperties(context, contentControl, "id").then(() => {
            const retVal = { id: contentControl.id };

            if (parentContentControl) {
                retVal.parentId = parentContentControl.id;
            }

            resolve(retVal);
        });
    });
});

export default {
    add
};